import { Component } from "@angular/core";

@Component({
  selector: "app-dossier",
  templateUrl: "./dossier.component.html",
  styleUrls: ["./dossier.component.scss"],
})
export class DossierComponent {}
